import { render, staticRenderFns } from "./er.vue?vue&type=template&id=63646251&scoped=true&"
import script from "./er.vue?vue&type=script&lang=js&"
export * from "./er.vue?vue&type=script&lang=js&"
import style0 from "./er.vue?vue&type=style&index=0&id=63646251&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63646251",
  null
  
)

export default component.exports